import React from "react";
import RailServicePage from "./RailServicePage";

export default function FamilyTrainTravel() {
  return (
    <RailServicePage
      eyebrow="Family Train Travel"
      title="Plan comfortable family train trips"
      description="Compare family-friendly rail routes, seating needs, baggage considerations, and schedules that work for group travel."
      icon="family"
      highlights={[
        {
          title: "Family seating support",
          text: "Get help planning around seating preferences, passenger ages, luggage, and station timing.",
        },
        {
          title: "Easier travel days",
          text: "Compare departures that leave enough time for boarding, transfers, and family logistics.",
        },
      ]}
      steps={[
        "Search your family route and travel dates.",
        "Choose passenger count and review route options.",
        "Call for help with seating, baggage, and ticket questions.",
      ]}
    />
  );
}
